// import React, { useState, useEffect } from "react";
// import queryString from "query-string";
// import io from "socket.io-client";

// import "./Chat.css";
// import ChatInput from "./Input/ChatInput";
// import Messages from "./Messages/Messages";
// import InfoBar from "./InfoBar/InfoBar";
// import TextContainer from "./TextContainer/TextContainer";

// const ENDPOINT = "http://localhost:8888";
// let socket;

// function Chat() {
//   const [name, setName] = useState("");
//   const [room, setRoom] = useState("");
//   const [users, setUsers] = useState("");
//   const [message, setMessage] = useState("");
//   const [messages, setMessages] = useState([]);

//   useEffect(() => {
//     const { name, room } = queryString.parse(window.location.search);
//     socket = io(ENDPOINT);
//     setName(name);
//     setRoom(room);
//     socket.emit("join", { name, room }, (err) => {
//       if (err) {
//         alert(err);
//       }
//     });
//     return () => {
//       socket.emit("disconnect");
//       socket.off();
//     };
//   }, [ENDPOINT, window.location.search]);

//   useEffect(() => {
//     socket.on("message", (message) => {
//       setMessages([...messages, message]);
//     });
//     socket.on("roomData", ({ users }) => {
//       setUsers(users);
//     });
//   }, []);

//   const sendMessage = (event) => {
//     event.preventDefault();
//     if (message) {
//       socket.emit("sendMessage", message, () => setMessage(""));
//     }
//   };

//   return (
//     <div className="outerContainer text-black">
//       <div className="container">
//         <InfoBar room={room} />
//         <Messages messages={messages} name={name} />
//         <ChatInput
//           message={message}
//           setMessage={setMessage}
//           sendMessage={sendMessage}
//         />
//       </div>
//       <TextContainer users={users} />
//     </div>
//   );
// }

// export default Chat;

import React, { useState, useEffect } from "react";
import queryString from "query-string";
import io from "socket.io-client";

// import InfoBar from "../components/InfoBar/InfoBar";
// import Input from "../components/Input/Input";
// import Messages from "../components/Messages/Messages";

import "./Chat.css";
import TextContainer from "./TextContainer/TextContainer";
import ChatInput from "./Input/ChatInput";
import Messages from "./Messages/Messages";
import InfoBar from "./InfoBar/InfoBar";
// import TextContainer from "../components/TextContainer/TextContainer";

const ENDPOINT = "http://localhost:8888";

let socket;

const Chat = ({ location }) => {
  const [name, setName] = useState("");
  const [room, setRoom] = useState("");
  const [users, setUsers] = useState("");
  const [message, setMessage] = useState("");
  const [messages, setMessages] = useState([]);

  useEffect(() => {
    // 여기선 name과 room을 url에서 가져온다.
    // 이유는 setRoom과 setName이 적용되기 전에 socket.emit('join')이 실행되기 때문이다.
    // url에서 가져오는 방법이 아닌 다른 방법으로 name과 room을 가져오려면
    // 미리 정해진 방법으로 name과 room을 가져오는 것이 아닌
    // socket.emit('join')이 실행되기 전에 setRoom과 setName이 실행되도록 해야 한다.
    const { name, room } = queryString.parse(window.location.search);

    console.log(name, room);

    socket = io(ENDPOINT);

    setRoom(room);
    setName(name);

    socket.emit("join", { name, room }, (error) => {
      if (error) {
        alert(error);
      }
    });
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  useEffect(() => {
    socket.on("message", (message) => {
      setMessages((messages) => [...messages, message]);
    });

    socket.on("roomData", ({ users }) => {
      setUsers(users);
    });
  }, []);

  const sendMessage = (event) => {
    event.preventDefault();

    if (message) {
      // console.log(message)
      socket.emit("sendMessage", message, () => setMessage(""));
    }
  };

  return (
    <div className="outerContainer">
      <div className="innerContainer">
        <InfoBar room={room} />
        <Messages messages={messages} name={name} />
        <ChatInput
          message={message}
          setMessage={setMessage}
          sendMessage={sendMessage}
        />
      </div>
      <TextContainer users={users} />
    </div>
  );
};

export default Chat;
